import { render, staticRenderFns } from "./ActivitiesListModal.vue?vue&type=template&id=6d99ed1a&"
import script from "./ActivitiesListModal.vue?vue&type=script&lang=js&"
export * from "./ActivitiesListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports